import React, { useState, useEffect, useRef } from 'react'
import $ from 'jquery';
import { getAssetAUM } from '../actions/assetDetailsActions';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useParams } from 'react-router-dom'
import { AssetDropDown } from "../UiComponents/AssetDropDown";
import { getAssestListddlAction } from "../actions/assetsddlAction";
import { GetAssetAUMOptAction } from "../actions/assetAUMAction";
import { getAsset } from "../actions/assetAction";
import { UrlPath } from "../../config/routeConfig";
import "ag-grid-enterprise";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { AgGridReact } from "ag-grid-react";
import moment from "moment";
import { useNavigate } from "react-router";
import download from '../../Images/download.svg';
import { exportToExcelUsingRef } from '../utils/excelExporter';
import { LoadingScreen } from "../UiComponents/LoadingComponent";
import "../asset/assetDetail/AssetAUM/AUMList.css";
import { SBADrawer } from "../UiComponents/SBADrawer";
import { SBDatePicker } from "../UiComponents/SBDatePicker";
import { NumericTextBox } from "@progress/kendo-react-inputs";
import { InsertorUpdateAUM, DeleteAUM,updateAssetAUMImportReturns,DownloadAUMImportTemplate, getAssetAUMOpt } from "../../config/apiConfig";
import { ToastContainer, toast } from 'react-toastify';
import { Modal } from "react-bootstrap";
import { sbaAxios } from '../utils/sbaAxios';
import { SBNotify } from "../utils/sbNotify";
import * as XLSX from 'xlsx';

export const AssetAUMList = () => {

    const emptyImportReturns = {
        selectedFile: null,
        FundLots: false,
        ExistingData: false,
        FinalReturns: false,
    }
    const dispatch = useDispatch();
    const params = useParams();
    const history = useNavigate();
    const gridApi = useRef(null);
    const aumRef = useRef();
    const currentDate = new Date();
    const previousMonth = currentDate.getMonth() - 1;
    const previousMonthEndDate = new Date(
        currentDate.getFullYear(),
        previousMonth + 1,
        0
    );
    const [showDrawer, setshowDrawer] = useState(false);
    const [aumData, setaumData] = useState([]);
    const [valuationDate, setvaluationDate] = useState();
    const [assetAUMValue, setassetAUMValue] = useState();
    const [assetValuationId, setassetValuationId] = useState();
    const [strategyAUMValue, setstrategyAUMValue] = useState();
    const [startegyValuationId, setstrategyValuationId] = useState();
    const [entityId, setentityId] = useState();
    const [firmAUMValue, setfirmAUMValue] = useState();
    const [firmValuationId, setfirmValuationId] = useState();
    const [showModal, setShowModal] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [selectedassetValuationId, setselectedassetValuationId] = useState();
    const [selectedstartegyValuationId, setselectedstrategyValuationId] = useState();
    const [selectedfirmValuationId, setselectedfirmValuationId] = useState();

    //Import Returns
    const [importReturnsDrawer, setImportReturns] = useState(false);
    const [drawerData, setDrawerData] = useState(emptyImportReturns)
    const [workbookFile, setWorkbookFile] = useState(null);
    const [importStatus,setImportStatus]=useState('Import');

    const [mode, setmode] = useState();
    const Gstate =
        useSelector((state) => {
            return state;
        }) || {};

    const isEditable = Gstate.authorizationData.isEditable;

    const AssetListDDL = Gstate.assetDDL.assetList || [];
    const [radioValue, setRadioValue] = useState(4);
    const AUMListData = (Gstate?.AssetAUMOpt?.AssetAUMOpt || []).map(item => {
        const formattedRow={
            ...item, 
            ValuationDate: getMonthFormatted(item.ValuationDate),
            AssetValue: FormatCurrencyGrid(item.AssetValue),
            StrategyValue: FormatCurrencyGrid(item.StrategyValue),
            FirmValue: FormatCurrencyGrid(item.FirmValue),
            AsofDate: getDateFormatted(item.ValuationDate),
        }
        return formattedRow;
    });
    const [aumListData,setAUMListData]=useState({});


    const [AUMLoading,setAUMLoading ]=useState(false);

    // Gstate.AssetAUMOpt.isLoading;
    
    const gridData=aumListData?.AumData?.map(item => {
        const formattedRow={
            ...item, 
            ValuationDate: getMonthFormatted(item.ValuationDate),
            AssetValue: FormatCurrencyGrid(item.AssetValue),
            StrategyValue: FormatCurrencyGrid(item.StrategyValue),
            FirmValue: FormatCurrencyGrid(item.FirmValue),
            AsofDate: getDateFormatted(item.ValuationDate),
        }
        return formattedRow;
    }) || [];
    const AssetAUM = aumListData?.AssetAUM || "";
    const StrategyAUM = aumListData?.StrategyAUM || "";
    const FirmAUM = aumListData?.FirmAUM || "";
    const SummaryAUM = aumListData ? aumListData[0] : "";

    const currentAsset = Gstate.asset.asset || {};
    useEffect(() => {
        document.title = `Asset AUM`;
    }, []);
    const GetAssetAUMOptData = (AssetId,opt) => {
        setAUMLoading(true);
            sbaAxios({
                url: `${getAssetAUMOpt}${AssetId},${opt}`,
                method: 'get',
            })
                .then((repos) => {
                    setAUMListData(repos);
                    setAUMLoading(false);
                })
                .catch((error) =>{
                    setAUMListData([]);
                    setAUMLoading(false);
                });
    }


    useEffect(() => {
        //   dispatch(getAssetAUM(params.AssetId, previousMonthEndDate));
        GetAssetAUMOptData(params.AssetId,radioValue)
        // dispatch(GetAssetAUMOptAction(params.AssetId, radioValue));
        dispatch(getAssestListddlAction());
        dispatch(getAsset(params.AssetId));
    }, []);
    const AssetDDChanged = (e) => {
        history(`${ UrlPath.Valuation}${e.value.AssetId}`);
        e.value && dispatch(getAsset(e.value.AssetId));      
        // dispatch(GetAssetAUMOptAction(e.value.AssetId, radioValue));
        GetAssetAUMOptData(e.value.AssetId,radioValue)

    };
    const OptionBasedAUM = (opt) => {
        setRadioValue(opt);
        // dispatch(GetAssetAUMOptAction(params.AssetId, opt));
        GetAssetAUMOptData(params.AssetId,opt)

    };
    
    const valuationDateChange = (selected) => {
        setvaluationDate(new Date(moment(selected).format('MM/DD/YYYY')));
    };

    const assetAUMValuechange = (event) => {
        setassetAUMValue(event.target.value);
    }
    const strategyAUMValuechange = (event) => {
        setstrategyAUMValue(event.target.value);
    }
    const firmAUMValuechange = (event) => {
        setfirmAUMValue(event.target.value);
    }
    const AUMNewPoup = () => {

        setvaluationDate(moment(previousMonthEndDate).format("MM-DD-YYYY"));
        setassetAUMValue('');
        setstrategyAUMValue('');
        setfirmAUMValue('');
        setentityId(params.AssetId);
        setmode("Add");
        setshowDrawer(true);
    };


    //Import Return methods

    const ImportReturnsClick = () => {
        setImportReturns(true);

    }


    const handleFileChange = (event) => {
        const { name } = event.target;
        const file = event.target.files[0];
        const updatedState = { ...drawerData, [name]: file };
        setDrawerData(updatedState);
    
        if (file) {
          const reader = new FileReader();
          reader.onload = (event) => {
            const fileContent = event.target.result;
    
              const workbook = XLSX.read(fileContent, { type: 'binary' ,cellDates: true});
            setWorkbookFile(workbookToSheetsArray(workbook));
          };
    
          reader.readAsBinaryString(file);
        }
      };
    
      const workbookToSheetsArray = (workbook) => {
        const sheetsArray = [];
        workbook.SheetNames.forEach((sheetName) => {
          const sheet = workbook.Sheets[sheetName];
          const table = XLSX.utils.sheet_to_json(sheet, { header: 1 });
          const formattedTable = formatTableWithNulls(table);
          sheetsArray.push({ name: sheetName, table: formattedTable });
        });
        return sheetsArray;
      };
      
      const formatTableWithNulls = (table) => {
        const headers = table[0];
      
        if (!validateHeaders(headers)) {
          return [];
        }
      
        return table.slice(1).map((row) => {
          const isRowEmpty = row.every((value) => value === undefined || value === null);
          if (isRowEmpty) {
            return null;
          }
          const formattedRow = {};
            headers.forEach((header, index) => {
                
            if (header === 'PriceDate') {
              const formattedDate = row[index];
                formattedRow[header] = formatExcelDate?formatExcelDate(formattedDate):null;
            } else {
              formattedRow[header] = row[index] === undefined ? null : row[index];
            }
          });
          return formattedRow;
        }).filter((row) => row !== null);
      };  
        const formatExcelDate = (inputDate) => {
           
            const date = new Date(inputDate);
            const month = date.getMonth() + 1; 
            const day = date.getDate();
            const year = date.getFullYear();
            const formattedMonth = month < 10 ? '0' + month : month;
            const formattedDay = day < 10 ? '0' + day : day;
            const formattedDate = `${formattedMonth}/${formattedDay}/${year}`;
    
            return formattedDate;
        };
      
      const validateHeaders = (headers) => {
        const requiredHeaders = ["AssetId", "EntityTypeId", "PriceDate",  "AssetAUM", "StrategyAUM","FirmAUM"];
     
        const missingHeaders = requiredHeaders.filter(header => !headers.includes(header));
        if (missingHeaders.length > 0) {
          return false;
        }
        return true;
      };  

     const saveImportReturns = async () => {
        let saveSuccess = true;
        let errorMSG=`Invalid Final Value Flag`;
        if(workbookFile?.length>0)
        {
          const mappedData = workbookFile[0].table.map((row) => ({
            EntityId: row.AssetId,
            EntityTypeId: row.EntityTypeId,
            ValuationDate: row.PriceDate
              ? moment(row.PriceDate).format("MM/DD/yyyy")
              : null,
            AssetAUM: row.AssetAUM,
            StrategyAUM: row.StrategyAUM,
            FirmAUM: row.FirmAUM
          }));
      
          const data = {
             mappedData
          };
      
          
          mappedData.forEach((row) => {
              
              if (params.AssetId != row.EntityId || row.EntityTypeId!==1) {
              errorMSG="AssetId in file doesn't match current selected asset";
              saveSuccess = false;
            }
          });
      
          if (
              data.mappedData.length === 0 || data.mappedData === "" ) {
            errorMSG= "Invalid File Format";
            saveSuccess = false;
          }
         
          if (saveSuccess) {
            const response = await sbaAxios({
              url: `${updateAssetAUMImportReturns}`,
              method: "post",
                data: mappedData,
            });
            if (response > 0) {
              setImportReturns(false);               
            //   dispatch(GetAssetAUMOptAction(params.AssetId, radioValue));
                GetAssetAUMOptData(params.AssetId,radioValue)

              SBNotify({ type: "success", Msg: "Import Successfully" });  
              
            } else {
              SBNotify({ type: "warning", Msg: "Failed" });
            }
            setImportStatus('Import');
          }
          else  {
            SBNotify({ type: "error", Msg: errorMSG });
            setImportStatus('Import');
          }
        }
        else {
          SBNotify({ type: "error", Msg: "Please Select Any File To Import" });
          setImportStatus('Import');  
    }

    let saveMsg="Invalid File Format";
    
    const mappedData = workbookFile[0].table.map((row) => {
        return{
        EntityId: row.AssetId,
        EntityTypeId: row.EntityTypeId,
        ValuationDate: row.PriceDate
            ? moment(row.PriceDate).format("MM/DD/yyyy")
            : null,
        AssetAUM: row.AssetAUM,
        StrategyAUM: row.StrategyAUM,
        FirmAUM: row.FirmAUM
    }});

    const data = {
        mappedData
    };
    
    if (
        data.mappedData.length === 0 || data.mappedData === "") {
        saveSuccess = false;
    };

    if (saveSuccess) {
        const response = await sbaAxios({
            url: `${updateAssetAUMImportReturns}`,
            method: "post",
            data: mappedData,
        });
        if (response > 0) {
            setImportReturns(false);
            // dispatch(GetAssetAUMOptAction(params.AssetId, radioValue));
            GetAssetAUMOptData(params.AssetId,radioValue)

            SBNotify({ type: "success", Msg: "Import Successfully" });
        } else {
            SBNotify({ type: "warning", Msg: "Failed" });
        }
    }
    else {
        SBNotify({ type: "error", Msg: saveMsg });
    }
};

const cancelImportReturns = () => {
    setImportReturns(false);
};

const DownloadFile=()=>
{
  sbaAxios({
    url: DownloadAUMImportTemplate ,
    responseType: 'blob'
}).then((response) => {
    var downloadLink = document.createElement('a');
    downloadLink.href = URL.createObjectURL(response);
    downloadLink.download = "AUMReturnsImportTemplate.xlsx";
    downloadLink.click();   
});

}

// End Import returns

    const ActionsRenderer = (props) => {
        const NavigatetoEdit = () => {
            if(isEditable !== false){
                setassetValuationId(props.data.AssetValuationId);
                setvaluationDate(props.data.AsofDate);
                setassetAUMValue(props.data.AssetValue === 0 ? '' : props.data.AssetValue);
                setstrategyValuationId(props.data.StrategyValuationId)
                setstrategyAUMValue(props.data.StrategyValue === 0 ? '' : props.data.StrategyValue);
                setfirmValuationId(props.data.FirmValuationId);
                setfirmAUMValue(props.data.FirmValue === 0 ? '' : props.data.FirmValue);
                setentityId(props.data.EntityId);
                setmode("Edit");
                setshowDrawer(true);
            }

        }
        const DeleteClick = () => {
            if(isEditable !== false){
                setShowDeleteModal(true);
                setselectedassetValuationId(props.data.AssetValuationId);
                setselectedstrategyValuationId(props.data.StrategyValuationId);
                setselectedfirmValuationId(props.data.FirmValuationId);
            }
        };
        return (

            <div className="actions-cell">
                <i className="fas fa-edit" style={{ color: isEditable === false ? "#808080" : "#47A547", margin: "0 8px", cursor: "pointer" }} onClick={NavigatetoEdit}></i>
                <i className="fa fa-trash" style={{ color: isEditable === false ? "#808080" : "#DF001B", margin: "0 8px", cursor: "pointer" }} onClick={DeleteClick}  ></i>
            </div>



        )
   

    };
    const cancelAUMpoup = () => {
        setshowDrawer(false);
    }
   

  
    const ColumnDefs = [
        {
            field: "ValuationDate",
            headerName: "Month",
            // valueFormatter: getMonthFormatted,

        },
        {
            field: "AsofDate",
            headerName: "As of Date",
            // valueFormatter: getDateFormatted,

        },
        {
            field: "AssetValue",
            headerName: "Asset AUM,MM",
            // valueFormatter: FormatCurrencyGrid,
            cellStyle: { textAlign: "right" },
            headerClass: 'header-align-right',
            // cellRenderer: params => {
            //     debugger;
            //     if (params.data.AssetValue === 0) {
            //         return ``;
            //     }
            //     else {
            //         return FormatCurrency(params.data.AssetValue);
            //     }

            // },
            minWidth: 100, maxWidth: 180

        },
        {
            field: "StrategyValue",
            headerName: "Strategy AUM,MM",
            // valueFormatter: FormatCurrencyGrid,
            cellStyle: { textAlign: "right" },
            headerClass: 'header-align-right',
            // cellRenderer: params => {
            //     if (params.data.StrategyValue === 0) {
            //         return ``;
            //     }
            //     else {
            //         return FormatCurrency(params.data.StrategyValue);
            //     }

            // },
            minWidth: 100, maxWidth: 180
        },
        {
            field: "FirmValue",
            headerName: "Firm AUM,MM",
            // valueFormatter: FormatCurrencyGrid,
            // valueFormatter: FormatCurrencyGrid,
            cellStyle: { textAlign: "right" },
            headerClass: 'header-align-right',
            // cellRenderer: params => {
            //     if (params.data.FirmValue === 0) {
            //         return ``;
            //     }
            //     else {
            //         return FormatCurrency(params.data.FirmValue);
            //     }

            // },
            minWidth: 100, maxWidth: 150
        },
        {
            field: "Action",
            headerName: "Action",
            cellRenderer: ActionsRenderer,
            filter: false,

        }
    ];
    const defaultColDef = {
        flex: 1,
        sortable: true,
        filter: true,
        resizable:true
    };
    const InsertorUpdateAUMDetails = (event) => {
        let saveSuccess = true;
        let errorMsg = [];

        event.preventDefault();
        // Prepare the data to be sent in the POST request
        const data = {
            "AssetId": parseInt(params.AssetId),
            "ValuationDate": valuationDate,
            "AssetValuationId": assetValuationId,
            "AssetValue": assetAUMValue ? parseFloat(String(assetAUMValue).replace(/[^0-9.]/g, '')) : 0,
            "StrategyValuationId": startegyValuationId,
            "StrategyValue": strategyAUMValue ? parseFloat(String(strategyAUMValue).replace(/[^0-9.]/g, ''))  : 0,
            "FirmValuationId": firmValuationId,
            "FirmValue": firmAUMValue ? parseFloat(String(firmAUMValue).replace(/[^0-9.]/g, ''))  : 0,
            "ModifiedBy": 0,
        };
        if ((!assetAUMValue) && (!strategyAUMValue) && (!firmAUMValue)) {
            saveSuccess = false;
            SBNotify({Msg:'Please nter at least one value',type:'error'});
        }
        if (saveSuccess) {
            sbaAxios({
                url: `${InsertorUpdateAUM}`,
                method: 'post',
                data: data,
            })
                .then((response) => {                   
                    SBNotify({Msg:'AUM Values Posted Successfully',type:'success'});
                    setshowDrawer(false);
                    // dispatch(GetAssetAUMOptAction(params.AssetId, radioValue));
                    GetAssetAUMOptData(params.AssetId,radioValue)
                    setassetValuationId(0);
                    setvaluationDate(null);
                    setassetAUMValue(0);
                    setstrategyValuationId(0)
                    setstrategyAUMValue(0);
                    setfirmValuationId(0);
                    setfirmAUMValue(0);
                    setentityId(0);
                })

                .catch((error) => {
                    SBNotify({Msg:'Failed to Post AUM',type:'error'});
                });
        }
    };

    const DeleteAumdetails = () => {
        setShowDeleteModal(false);
        sbaAxios({
            url: `${DeleteAUM}AssetValuationId=${selectedassetValuationId}&StrategyValuationId=${selectedstartegyValuationId}&FirmValuationId=${selectedfirmValuationId}`,
            method: 'Post',
        }).then(response => {
            setTimeout(() => {
                SBNotify({Msg: "AUM  Deleted Successfully",type:'success'});
                // dispatch(GetAssetAUMOptAction(params.AssetId, radioValue));
                GetAssetAUMOptData(params.AssetId,radioValue)

            }, 100);
        })
            .catch(error => {
                console.error('Error deleting data:', error);
            });
    }
    const closeModal = () => {
        setShowDeleteModal(false);
    };
    return (
        <div className="AUMdiv">

            {AUMLoading ? (
                <LoadingScreen />
            ) : (
                <>
                    
                    <div class="p-4">

                        <div>

                            <div className="col-lg-12 d-flex gap-3  p-0 align-items-center">
                                <h2 class="fw-medium fs-6 m-0">{currentAsset?.AssetName}</h2>
                                <div
                                    className="d-flex gap-1  justify-content-lg-end p-0 align-items-center"
                                    style={{ marginLeft: "auto" }}
                                >
                                    <div style={{ width: "300px" }}>
                                        <AssetDropDown
                                            value={currentAsset}
                                            onChange={AssetDDChanged}
                                            data={AssetListDDL}
                                        />
                                    </div>
                                    <div className="d-flex gap-2">
                                      <button className="p-sm-btn mx-1" disabled={!isEditable} onClick={ImportReturnsClick} >Import Returns</button>
                                        <button className="p-sm-btn mx-1" disabled={!isEditable} onClick={AUMNewPoup} >
                                            <i className="fa-solid fa-plus" /> Add
          </button>
                                        <button
                                            type="button"
                                            className="p-sm-btn mx-1"
                                            onClick={() => {
                                                exportToExcelUsingRef(aumRef, "Asset AUM List.xlsx");
                                            }}
                                        >
                                            <img src={download} alt="" />
                      Export
                    </button>
                                    </div>
                                </div>
                            </div>
                            <div><br></br></div>
                        </div>
                        <div className='d-flex p-0 m-0' style={{ width: "99%" }}>
                            <div class="detail m-1 p-3 col-md-4">
                                <div class="row p-1 border-bottom  m-0">
                                    <div class="col-6 left">
                                        <span class="fw-medium">Asset, MM</span>
                                    </div>
                                </div>
                                <div class="row p-1 m-0">
                                    <div class="col-6 left">
                                        <span>For Selected Range</span>
                                    </div>
                                    <div class="col-6 text-sm-end">
                                        <span>{AssetAUM ? FormatCurrency(AssetAUM) : "N/A"}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="detail m-1 p-3 col-md-4">
                                <div class="row p-1 border-bottom  m-0">
                                    <div class="col-6 left">
                                        <span class="fw-medium">Strategy, MM</span>
                                    </div>
                                </div>
                                <div class="row p-1 m-0">
                                    <div class="col-6 left">
                                        <span>For Selected Range</span>
                                    </div>
                                    <div class="col-6 text-sm-end">
                                        {StrategyAUM ? FormatCurrency(StrategyAUM) : "N/A"}
                                    </div>
                                </div>
                            </div>
                            <div class="detail m-1 p-3 col-md-4">
                                <div class="row p-1 border-bottom m-0">
                                    <div class="col-6 left">
                                        <span class="fw-medium">Firm, MM </span>
                                    </div>
                                </div>
                                <div class="row p-1 m-0">
                                    <div class="col-6 left">
                                        <span>For Selected Range</span>
                                    </div>
                                    <div class="col-6 text-sm-end">
                                        <span> {FirmAUM ? FormatCurrency(FirmAUM) : "N/A"}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <br></br>
                        <div
                            className="AUMYearRG d-flex gap"
                        >
                            <span className="radioSelectorGroup">
                                <div>
                                    <span
                                        className={
                                            radioValue === 0
                                                ? "selected YearRadioSpan"
                                                : "YearRadioSpan"
                                        }
                                        onClick={() => {
                                            OptionBasedAUM(0);
                                        }}
                                    >
                                        1Y
                    </span>
                                </div>
                                <div>
                                    <span
                                        className={
                                            radioValue === 1
                                                ? "selected YearRadioSpan"
                                                : "YearRadioSpan"
                                        }
                                        onClick={() => {
                                            OptionBasedAUM(1);
                                        }}
                                    >
                                        3Y
                    </span>
                                </div>
                                <div>
                                    <span
                                        className={
                                            radioValue === 2
                                                ? "selected YearRadioSpan"
                                                : "YearRadioSpan"
                                        }
                                        onClick={() => {
                                            OptionBasedAUM(2);
                                        }}
                                    >
                                        5Y
                    </span>
                                </div>
                                <div>
                                    <span
                                        className={
                                            radioValue === 3
                                                ? "selected YearRadioSpan"
                                                : "YearRadioSpan"
                                        }
                                        onClick={() => OptionBasedAUM(3)}
                                    >
                                        10Y
                    </span>
                                </div>
                                <div>
                                    <span
                                        className={
                                            radioValue === 4
                                                ? "selected YearRadioSpan"
                                                : "YearRadioSpan"
                                        }
                                        onClick={() => OptionBasedAUM(4)}
                                    >
                                        ITD
                    </span>
                                </div>
                                {/* <div>
                     
                          <span
                            className={
                              radioValue === 5 
                                ? "selected YearRadioSpan"
                                : "YearRadioSpan"
                            }
                            onClick={()=>OptionBasedAUM(5)}
                          >
                            Custom
                          </span>
                      
                      </div> */}
                            </span>
                        </div>


                        <div>
                            <div
                                className="d-flex gap-4 justify-content-end "
                                style={{ marginTop: "1%" }}
                            ></div>
                        </div>

                        <div
                            className="ag-theme-alpine"
                            style={{ width: "100%", height: "700px" }}
                        >
                            <AgGridReact
                                ref={aumRef}
                                columnDefs={ColumnDefs}
                                rowData={gridData}
                                defaultColDef={defaultColDef}
                                pagination={true}
                                paginationPageSize={20}
                                onGridReady={(params) => {
                                    gridApi.current = params.api;
                                }}
                            ></AgGridReact>
                        </div>
                    </div>
                </>
            )}
            <SBADrawer open={showDrawer} setOpen={setshowDrawer} close={false} title={'Post AUM (values in millions)'}>
                <div>

                    <label className="header-container m-1"><b>Valuation Date</b></label>
                    <div>
                        <SBDatePicker popupSettings={{ className: 'modalDD' }} className="w-75" id="txtValuationDate" value={moment(valuationDate)} onChange={valuationDateChange}>
                        </SBDatePicker>
                    </div>
                    <br></br>
                    <label className="header-container m-1"><b>Asset AUM </b></label>
                    <div>
                        <NumericTextBox className="w-75"
                            defaultValue={assetAUMValue}
                             onChange={assetAUMValuechange}
                        />
                    </div>
                    <br></br>
                    <label className="header-container m-1"><b>Strategy AUM</b></label>
                    <div>
                        <NumericTextBox className="w-75"
                            defaultValue={strategyAUMValue}
                            onChange={strategyAUMValuechange}
                        />
                    </div>
                    <br></br>
                    <label className="header-container m-1"><b>Firm AUM</b></label>
                    <div>
                        <NumericTextBox className="w-75"
                            defaultValue={firmAUMValue}
                            onChange={firmAUMValuechange}
                        />
                    </div>
                    <div className="mt-4">
                        <button className="s-sm-btn mx-1" onClick={cancelAUMpoup}>
                            Cancel
                        </button>
                        {mode === "Edit" && (
                            <button className="p-sm-btn mx-1" onClick={InsertorUpdateAUMDetails} disabled={!isEditable}>
                                Update
                            </button>
                        )}
                        {mode === "Add" && (
                            <button className="p-sm-btn mx-1" onClick={InsertorUpdateAUMDetails} disabled={!isEditable}>
                                Save
                            </button>
                        )}
                    </div>

                </div>
            </SBADrawer>

            <SBADrawer
              open={importReturnsDrawer}
              setOpen={setImportReturns}
              close={false}
              title={`Import Returns`}
             // size={"50rem"}
            >
              <div> {importStatus==='Importing' ?  <><LoadingScreen/></> : <>
                <div className="col-lg-12 row m-0 mb-4 gap-2">
                  <div className="col-md-6">
                    <div className="mb-4">
                      <span className="fw-medium">Select Asset</span>
                      <AssetDropDown
                        value={currentAsset}
                        data={AssetListDDL}
                        popupSettings={{ className: "modalDD" }}
                        disabled
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="mb-4">
                      <span className="fw-medium">Select File</span>
                      <input type="file"  accept=".xls,.xlsx" name="selectedFile" onChange={handleFileChange}/>
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="mb-4">
                    <span className="fw-medium">
                    <Link onClick={DownloadFile}> Download returns import file</Link>
                    </span>
                  </div>
                </div>
                <div className="col-lg-12 row m-0 mb-4 gap-2">
                </div>
                <div className="mt-4">
                  <button className="s-sm-btn mx-1" onClick={cancelImportReturns}>Cancel</button>
                  <button className="p-sm-btn mx-1"  disabled={importStatus==='Importing'} onClick={()=>{setImportStatus('Importing'); saveImportReturns()}}>{importStatus}</button>
                </div></>}
              </div>
            </SBADrawer>
            <Modal show={showDeleteModal}  >
                <Modal.Header closeButton onClick={closeModal}>
                    <Modal.Title>Do you want to delete the selected AUM?</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>The selected AUM will be deleted permanently. Are you sure?</p>
                </Modal.Body>
                <Modal.Footer>
                    <button className="s-sm-btn mx-1" onClick={closeModal} > Cancel</button>
                    <button className='p-sm-btn mx-1' onClick={DeleteAumdetails} disabled={!isEditable} >
                        Yes
          </button>
                </Modal.Footer>
            </Modal>
            {/* <ToastContainer></ToastContainer> */}
        </div>
    );
}
const FormatCurrency = (val) => {
    if (val == null || isNaN(val)) {
        return val; 
    }
    return (
        "$ " +
        val.toLocaleString("en-US", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        }) +
        " MM"
    );
};
const getMonthFormatted = (params) => {
    const formattedDate = moment(params).format("MMM-YYYY");
    return formattedDate;
};
const getDateFormatted = (params) => {
    return moment(params).format("MM-DD-YYYY");
};
const FormatCurrencyGrid = (val) => {
    if (val == null || isNaN(val)) {
        return ""; 
    }
    if (val == 0) {
        return ""; 
    }
    return (
        "$ " +
        val.toLocaleString("en-US", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        }) +
        " MM"
    );
};



